import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/basket', request)
}

export {post}
